import React from 'react';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import { IconInfo } from '@americanexpress/dls-react';
import styles from './infoBox.module.scss';
import Selectors from 'src/utils/selectors';
export interface InfoBoxProps {
    text: string;
    className?: string;
}

export default function InfoBox({ text, className }: InfoBoxProps): JSX.Element {
    return (
        <div className={`${styles.infoBox} ${className}`} data-cy={Selectors.SpendSmart.INFO_BOX}>
            <IconInfo className={styles.icon} data-cy={Selectors.SpendSmart.INFO_ICON} />
            <Typography
                variant={TypographyVariants.BODY}
                className={styles.text}
                component="p"
                data-cy={Selectors.SpendSmart.INFO_BOX_TEXT}
            >
                {text}
            </Typography>
        </div>
    );
}
